import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Flex, Box } from 'components/Grid';
import { mq, sizes } from 'utils/styles/theme';
import H1 from 'components/H1';

import Text from 'components/Text';
import Animate from 'components/Animate';
import MultiMediaBlock from 'components/MultiMediaBlock';
import handIcon from '../../images/hand-vink.svg';
import Image from 'components/Image';
import Type from 'components/Type';

const HomeHeroStyled = styled(Flex)`
	position: relative;
	display: flex;
	align-items: flex-end;
	height: calc(100vh - ${sizes.headerHeight});

	.HomeHero__Media {
		position: absolute;
		top: 0;
		right: 0;
	}
	.HomeHero__TextBlock {
		z-index: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 100%;

		${mq.small} {
			width: 70%;
		}

		${mq.xlarge} {
			width: 40%;
		}

		.TextBlock__Arrow {
			position: absolute;
			right: 20px;
			bottom: 20px;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;

			${mq.small} {
				right: 30px;
				bottom: 30px;
			}

			span {
				writing-mode: vertical-lr;
				transform: rotate(180deg);
				text-transform: uppercase;
			}

			img {
				transform: rotateX(360deg);
			}
		}

		.type-it-text {
			background: black;
			color: white;
			padding: 0 10px;
			margin-left: 10px;
			width: 108px;
			height: 100%;
			display: inline-block;
			text-align: center;
		}

		.TextBlock__TextWrapper {
			max-width: 790px;
			display: flex;
			flex-direction: column;

			.TextBlock__Text {
				flex-grow: 1;
			}

			img {
				margin-left: 5px;
			}
		}
	}
`;

const HomeHero = props => {
	const getTypeItTexts = () => {
		const words = props.introText.value.split(' ');

		return words.map(word => {
			const match = word.match(/__.*?__/);
			if (match) {
				const strippedWord = match[0].replace(/_/g, '');
				const wordArray = strippedWord.split('|');

				return <Type key={word} words={wordArray} />;
			}

			return ` ${word}`;
		});
	};

	const text = getTypeItTexts();

	return (
		<HomeHeroStyled>
			<Box
				className="HomeHero__Media"
				height={['100%', '100%', '65vh']}
				width={['100%', '100%', '65%']}
			>
				<MultiMediaBlock mediaEl={props.heroImage} />
			</Box>
			<Box
				className="HomeHero__TextBlock"
				color="white"
				bg="client.primaryOpacity"
				minHeight={['100%', '100%', '65%']}
				// width={['60%', '60%', '40%']}
				px={[4, 5, 6]}
				py={[4, 5, 7]}
			>
				<div className="TextBlock__TextWrapper">
					<Box className="TextBlock__Text">
						<Animate animateOnInView>
							<H1 fontSize={['h2', 'h1', 'h1']}>{props.headline}</H1>
						</Animate>

						<Animate animateOnInView delay={200}>
							<Box width={['80%', '100%']}>
								<Text fontSize={['p', 'pLarge']}>{props.introText && getTypeItTexts()}</Text>
							</Box>
						</Animate>
					</Box>
					<div className="TextBlock__Arrow">
						<Text color="black" as="span" fontWeight="bold" fontSize="12px">
							Hur kan vi hjälpa dig?
						</Text>
						<Image width="25px" staticImg src={handIcon} mt={2} />
					</div>
					{/* <Animate animateOnInView>
					</Animate> */}
				</div>
			</Box>
		</HomeHeroStyled>
		// <HomeHeroStyled grid gridTemplateColumns={'repeat(12, calc(100vw / 12))'}>
		// 	<Box
		// 		className="HomeHero__Media"
		// 		height={['auto', '85vh']}
		// 		position="relative"
		// 		gridColumn={['1 /-1', '1 /-1', '3 / -1']}
		// 		gridRow={['1', '1 / 1']}
		// 	>
		// 		<MultiMediaBlock mediaEl={props.heroImage} />
		// 	</Box>
		// 	<Box
		// 		className="HomeHero__TextBlock"
		// 		color="white"
		// 		bg="client.primary"
		// 		width={[11 / 12, 1]}
		// 		pr={[4, 4, 7]}
		// 		pl={[4, 4, 7]}
		// 		pt={[5, 5, 7]}
		// 		pb={[3, 5, 5]}
		// 		position={['relative']}
		// 	>
		// 		<div className="TextBlock__TextWrapper">
		// 			<div className="TextBlock__Text">
		// 				<Animate animateOnInView>
		// 					<H1 fontSize={['h2', 'h1']}>{props.headline}</H1>
		// 				</Animate>
		// 				<Animate animateOnInView delay={200}>
		// 					<Text fontSize={['p', 'pLarge']}>{props.introText && getTypeItTexts()}</Text>
		// 				</Animate>
		// 			</div>
		// 			<Animate animateOnInView>
		// 				<Image width="40px" staticImg src={handIcon} mt={5} />
		// 			</Animate>
		// 		</div>
		// 	</Box>
		// </HomeHeroStyled>
	);
};

export default HomeHero;
